














import { Component, Vue } from 'vue-property-decorator';
import { mapGetters } from 'vuex';

import GiftPlans from 'frontend/views/premium/gifts/paywall/GiftPlans.vue';
import GiftReviews from 'frontend/views/premium/gifts/paywall/GiftReviews.vue';
import BrilliantAudience from 'frontend/views/premium/components/BrilliantAudience.vue';
import PaywallFeaturesList from 'frontend/views/premium/components/PaywallFeaturesList.vue';
import PaywallSimpleFeaturesList from 'frontend/views/premium/components/PaywallSimpleFeaturesList.vue';
import PaywallCoursesList from 'frontend/views/premium/components/PaywallCoursesList.vue';
import GiftPaywallFooter from 'frontend/views/premium/gifts/paywall/GiftPaywallFooter.vue';
import { MobileGetter } from 'frontend/types';

@Component({
  components: {
    BrilliantAudience,
    GiftPaywallFooter,
    GiftPlans,
    GiftReviews,
    PaywallCoursesList,
    PaywallFeaturesList,
    PaywallSimpleFeaturesList,
  },
  computed: {
    ...mapGetters('pageHeader', ['isMobile']),
  },
  metaInfo: {
    title: 'Give Brilliant Premium',
  },
})
export default class GiftPaywall extends Vue {
  private readonly isMobile!: MobileGetter;
}
